import { useAtomValue } from "jotai";
import { useEffect, useState } from "react";

import { LS_SelectedCoursesOpenEngagements } from "../../../data/learningSystem/engagement/selectedCourses";

import { refreshLearningSystemDataAtom } from "../../../data/learningSystem";

import { mixColorFamilies, portalColors } from "../../../style";
import EngagementCards from "./EngagementCards";
import {
	engagementFiltersAtom,
	separatedEngagementFiltersAtom,
} from "../../../data/learningSystem/engagement/filters";
import { LS_Engagement } from "../../../data/learningSystem/types";

/** Display a table of all open engagements for the selected courses. */
export default function OpenEngagements() {
	const openEngagements = useAtomValue(LS_SelectedCoursesOpenEngagements);
	const dataRefreshing = useAtomValue(refreshLearningSystemDataAtom);

	const allEngagementFilters = useAtomValue(engagementFiltersAtom);
	const separatedEngagementFilters = useAtomValue(
		separatedEngagementFiltersAtom,
	);

	// Prepare the data
	const [preparedData, setPreparedData] = useState<LS_Engagement[]>([]);

	useEffect(() => {
		if (!dataRefreshing) {
			if (!allEngagementFilters.length) {
				setPreparedData(openEngagements);
			} else {
				// Step 1: Filter "in" records for inclusion filters
				const mergedInclusionFilters = [
					...separatedEngagementFilters.inclusionTags,
					...separatedEngagementFilters.inclusionTasks,
				];

				const includedByFilters = mergedInclusionFilters.length
					? openEngagements.filter((engagement) => {
							return mergedInclusionFilters.some((inclusionFilter) => {
								return (
									(inclusionFilter.entity === "tag" &&
										engagement.data.metadata.tags?.[
											inclusionFilter.tag.category
										]?.includes(inclusionFilter.tag.name)) ||
									(inclusionFilter.entity === "task" &&
										engagement.data.metadata.tasks?.find(
											(task) => task.name === inclusionFilter.task.name,
										)?.complete === inclusionFilter.task.completed)
								);
							});
					  })
					: openEngagements;

				// Step 2: Filter "out" records for exclusion filters
				const mergedExclusionFilters = [
					...separatedEngagementFilters.exclusionTags,
					...separatedEngagementFilters.exclusionTasks,
				];

				const excludedByFilters = mergedExclusionFilters
					? includedByFilters.filter((engagement) =>
							mergedExclusionFilters.every(
								(exclusionFilter) =>
									(exclusionFilter.entity === "tag" &&
										engagement.data.metadata.tags?.[
											exclusionFilter.tag.category
										]?.includes(exclusionFilter.tag.name)) ||
									(exclusionFilter.entity === "task" &&
										engagement.data.metadata.tasks?.find(
											(task) => task.name === exclusionFilter.task.name,
										)?.complete === exclusionFilter.task.completed),
							),
					  )
					: includedByFilters;

				setPreparedData(excludedByFilters);
			}
		}
	}, [
		dataRefreshing,
		openEngagements,
		allEngagementFilters,
		separatedEngagementFilters,
	]);

	return (
		<EngagementCards
			chartTitle={{
				callOut: "In-Progress Courses",
				text: "Courses started, but not yet completed during selected timeframe",
			}}
			colorTheme={mixColorFamilies(portalColors.yellow, portalColors.gray, 0.6)}
			// transparentBackground={true}
			// margins={{ horizontal: 0, vertical: 0 }}
			dataRefreshing={dataRefreshing}
			observations={preparedData}
			engagementState="in-progress"
		/>
	);
}
